import React from 'react';
import { useNavigate } from 'react-router-dom';

const EducatorSignup = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full p-8 bg-white rounded-lg shadow-lg">
        <h1 className="text-3xl font-bold mb-6 text-center">Educator Signup</h1>
        <p className="text-gray-600 text-center mb-4">Coming soon...</p>
        <button
          onClick={() => navigate('/')}
          className="w-full bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default EducatorSignup;